import ApprovalConfirmationPage from './approver/ApprovalConfirmationPage'
import CodeController from './approver/CodeController'
import DirectNoticePage from './approver/DirectNoticePage'
import ParentEmailConfirmationPage from './approver/ParentEmailConfirmationPage'
import LoadingPage from './LoadingPage'
import LogoutPage from './LogoutPage'
import NotFoundPage from './NotFoundPage'
import ChildLandingPage from './requestor/ChildLandingPage'
import CompleteRequestPage from './requestor/CompleteRequestPage'
import PendingPage from './requestor/PendingPage'
import PlatformLoginPage from './requestor/PlatformLoginPage'

export {
  ApprovalConfirmationPage,
  ChildLandingPage,
  CodeController,
  CompleteRequestPage,
  DirectNoticePage,
  LoadingPage,
  LogoutPage,
  NotFoundPage,
  ParentEmailConfirmationPage,
  PendingPage,
  PlatformLoginPage,
}
